var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[(_vm.role!='Store')?_c('sidebar-item',{attrs:{"link":{
                name: 'Ordenes',
                path: '/ordenes',
                icon: 'img/theme/icn_ordenes.svg'
              }}}):_vm._e(),(_vm.role=='Super')?_c('sidebar-item',{attrs:{"link":{
                name: 'Hospitales',
                path: '/hospitales',
                icon: 'img/theme/icn_hospitales.svg'
              }}}):_vm._e(),(_vm.role=='Super')?_c('sidebar-item',{attrs:{"link":{
                name: 'Áreas',
                path: '/areas',
                icon: 'img/theme/icn_hospitales.svg'
              }}}):_vm._e(),(_vm.role=='Super')?_c('sidebar-item',{attrs:{"link":{
                name: 'Modelos',
                path: '/modelos',
                icon: 'img/theme/icn_modelos.svg'
              }}}):_vm._e(),(_vm.role!='Store')?_c('sidebar-item',{attrs:{"link":{
                name: 'Usuarios',
                path: '/usuarios',
                icon: 'img/theme/icn_usuarios.svg'
              }}}):_vm._e(),(_vm.role!='Admin')?_c('sidebar-item',{attrs:{"link":{
                name: 'Estatus del pedido',
                path: '/pedidos/estado',
                icon: 'img/theme/icn_estatus.svg'
              }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }